/**
 * Why Keido: the "What changes" accordion (paragraph--outcome-list).
 *
 * The rows are complete in the HTML: the first panel is open, the rest
 * carry the hidden attribute, which a noscript rule in the template lifts
 * so the page reads in full without this file. Here one row is open at a
 * time, clicking the open row closes it, and the panel's height and
 * opacity animate on --transition-base (grid-template-rows 0fr -> 1fr),
 * unless the visitor prefers reduced motion.
 */

(function (Drupal, once) {
  "use strict";

  /**
   * @param {HTMLElement} root
   *   The list ([data-k-outcomes]).
   */
  function init(root) {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const items = Array.from(root.querySelectorAll("[data-k-outcome]"))
      .map((item) => ({
        item,
        toggle: item.querySelector("[data-k-outcome-toggle]"),
        panel: item.querySelector("[data-k-outcome-panel]"),
      }))
      .filter((row) => row.toggle && row.panel);

    const isOpen = (row) => row.toggle.getAttribute("aria-expanded") === "true";

    const set = (row, open) => {
      row.toggle.setAttribute("aria-expanded", open ? "true" : "false");
      row.item.classList.toggle("is-open", open);
      if (open) {
        row.panel.hidden = false;
        if (reduce) {
          row.panel.classList.add("is-open");
          return;
        }
        // Two frames: the panel must be laid out at 0fr before it grows.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => row.panel.classList.add("is-open"));
        });
        return;
      }
      row.panel.classList.remove("is-open");
      if (reduce) {
        row.panel.hidden = true;
        return;
      }
      const done = (event) => {
        if (event.target !== row.panel) {
          return;
        }
        row.panel.removeEventListener("transitionend", done);
        if (!row.panel.classList.contains("is-open")) {
          row.panel.hidden = true;
        }
      };
      row.panel.addEventListener("transitionend", done);
    };

    items.forEach((row) => {
      // The server's state is the starting point.
      const open = isOpen(row);
      row.panel.hidden = !open;
      row.panel.classList.toggle("is-open", open);
      row.item.classList.toggle("is-open", open);

      row.toggle.addEventListener("click", () => {
        const wasOpen = isOpen(row);
        items.forEach((other) => {
          if (other !== row && isOpen(other)) {
            set(other, false);
          }
        });
        set(row, !wasOpen);
      });
    });
  }

  Drupal.behaviors.keidoOutcomes = {
    attach(context) {
      once("keidoOutcomes", "[data-k-outcomes]", context).forEach(init);
    },
  };
})(Drupal, once);
